// src/pages/FaturaGirisi.js
import React, { useEffect, useState } from "react";
import { db, auth } from "../firebaseConfig";
import {
  collection,
  getDocs,
  addDoc,
  serverTimestamp,
  Timestamp,
  query,
  where,
} from "firebase/firestore";

const FaturaGirisi = () => {
  const [firmalar, setFirmalar] = useState([]);
  const [plakalar, setPlakalar] = useState([]);
  const [urunler, setUrunler] = useState([]);
  const [faturaNolari, setFaturaNolari] = useState([]);
  const [satirlar, setSatirlar] = useState([
    {
      faturaNo: "",
      firmaAdi: "",
      firmaId: "",
      tarih: getBugun(),
      plaka: "",
      urunAdi: "",
      fiyat: "",
      adet: 1,
      iskonto: "",
      kdv: "",
      aciklama: "",
    },
  ]);

  function getBugun() {
    return new Date().toISOString().split("T")[0];
  }

  // --- veri çekme ---
  useEffect(() => {
    const fetchData = async () => {
      const firmaSnap = await getDocs(collection(db, "firms"));
      const firmaList = firmaSnap.docs
        .filter((d) => d.data().active !== false)
        .map((d) => ({
          id: d.id,
          adi: d.data().firmaAdi,
          kdvOrani: d.data().kdvOrani ?? 18,
        }))
        .sort((a, b) => a.adi.localeCompare(b.adi));
      setFirmalar(firmaList);

const plakaSnap = await getDocs(collection(db, "plates"));
const plakaList = plakaSnap.docs
  .filter((d) => d.data().active === true) // 👈 Sadece pasif (false) olmayanları al
  .map((d) => d.data().plate)
  .filter((p) => p) // Boş olanları temizle
  .sort();
setPlakalar(plakaList);

      const faturaSnap = await getDocs(collection(db, "faturalar"));
      const eskiUrunler = faturaSnap.docs.flatMap((doc) =>
        (doc.data().satirlar || []).map((s) => s.urunAdi)
      );
      setUrunler([...new Set(eskiUrunler)].sort());

      const noList = faturaSnap.docs
        .filter((d) => !d.data().deleted)
        .map((d) => d.data().faturaNo);
      setFaturaNolari(noList);
    };
    fetchData();
  }, []);

  // --- tablo içi değişiklik ---
  const handleChange = (i, key, value) => {
    const yeni = [...satirlar];
    if (key === "urunAdi") {
      value = value.toLocaleUpperCase("tr-TR");
    }

    // Ondalık sayı kontrolü
    if ((key === "fiyat" || key === "adet") && value) {
      value = value.replace(",", "."); // Virgül yerine nokta
      if (!/^\d*\.?\d*$/.test(value)) return; // Geçersiz giriş engelle
    }

    yeni[i][key] = value;

    if (key === "firmaAdi") {
      const secilen = firmalar.find((f) => f.adi === value);
      if (secilen) {
        yeni[i].firmaId = secilen.id;
        yeni[i].kdv = secilen.kdvOrani;
      } else {
        yeni[i].firmaId = "";
        yeni[i].kdv = "";
      }
      if (i > 0 && !value) yeni[i].firmaAdi = satirlar[i - 1].firmaAdi;
    }

    if (key === "tarih" && i > 0 && !value) yeni[i].tarih = satirlar[i - 1].tarih;
    if (key === "plaka" && i > 0 && !value) yeni[i].plaka = satirlar[i - 1].plaka;

    setSatirlar(yeni);

    // otomatik yeni satır
    if (i === satirlar.length - 1) {
      const { firmaAdi, faturaNo, tarih, urunAdi, fiyat, adet, kdv, firmaId, plaka } = yeni[i];
      if (firmaAdi && faturaNo && tarih && urunAdi && fiyat && adet && kdv !== "" && firmaId && plaka) {
        setSatirlar((prev) => [
          ...prev,
          {
            faturaNo,
            firmaAdi,
            firmaId,
            tarih,
            plaka,
            urunAdi: "",
            fiyat: "",
            adet: 1,
            iskonto: "",
            kdv: yeni[i].kdv,
            aciklama: "",
          },
        ]);
      }
    }
  };

  // --- kaydet ---
  const handleKaydet = async () => {
    const aktifSatirlar = satirlar.filter(
      (s) =>
        s.firmaAdi &&
        s.faturaNo &&
        s.tarih &&
        s.plaka &&
        s.urunAdi &&
        s.fiyat &&
        s.adet &&
        s.kdv !== "" &&
        s.firmaId
    );

    if (aktifSatirlar.length === 0) {
      alert("Kaydedilecek geçerli satır bulunamadı.");
      return;
    }

    const faturaGruplari = aktifSatirlar.reduce((acc, s) => {
      if (!acc[s.faturaNo]) acc[s.faturaNo] = [];
      acc[s.faturaNo].push(s);
      return acc;
    }, {});

    let basariylaKaydedilen = 0;

    for (const [faturaNo, grup] of Object.entries(faturaGruplari)) {
      const ilk = grup[0];

      // aynı fatura kontrolü
      const q = query(
        collection(db, "faturalar"),
        where("faturaNo", "==", faturaNo),
        where("firmaId", "==", ilk.firmaId),
        where("deleted", "==", false)
      );
      const snapshot = await getDocs(q);
      if (!snapshot.empty) {
        alert(`Fatura no zaten kayıtlı: ${faturaNo}`);
        continue;
      }

      const farkliFirma = grup.some((s) => s.firmaAdi !== ilk.firmaAdi);
      const farkliTarih = grup.some((s) => s.tarih !== ilk.tarih);
      if (farkliFirma || farkliTarih) {
        alert(`Fatura No: ${faturaNo} için firma ve tarih aynı olmalıdır.`);
        continue;
      }

      const satirlarVeri = grup.map(({ urunAdi, fiyat, adet, iskonto, kdv, aciklama, plaka }) => ({
        urunAdi,
        fiyat: parseFloat(fiyat),
        adet: parseFloat(adet),
        iskonto: iskonto ? parseFloat(iskonto) : 0,
        kdv: parseFloat(kdv),
        aciklama,
        plaka,
      }));

      await addDoc(collection(db, "faturalar"), {
        faturaNo,
        firmaAdi: ilk.firmaAdi,
        firmaId: ilk.firmaId,
        tarih: Timestamp.fromDate(new Date(ilk.tarih)),
        createdAt: serverTimestamp(),
        createdBy: auth.currentUser?.email || "anonim",
        satirlar: satirlarVeri,
        deleted: false,
        faturaAcik: "",
      });

      basariylaKaydedilen++;
    }

    if (basariylaKaydedilen > 0) {
      alert("Tüm geçerli faturalar kaydedildi ✅");
      setSatirlar([
        {
          faturaNo: "",
          firmaAdi: "",
          firmaId: "",
          tarih: getBugun(),
          plaka: "",
          urunAdi: "",
          fiyat: "",
          adet: 1,
          iskonto: "",
          kdv: "",
          aciklama: "",
        },
      ]);
    }
  };

  // --- Toplam Hesaplama ---
const toplam = satirlar.reduce(
  (acc, s) => {
    const adet = parseFloat(s.adet) || 0;
    const fiyat = parseFloat(s.fiyat) || 0;
    const iskonto = parseFloat(s.iskonto) || 0;
    const kdvOrani = parseFloat(s.kdv) || 0;

    const tutar = adet * fiyat;
    const iskontoTutar = tutar * (iskonto / 100);
    const net = tutar - iskontoTutar;
    const kdvTutar = net * (kdvOrani / 100);

    acc.tutar += tutar;
    acc.iskonto += iskontoTutar;
    acc.net += net;
    acc.kdvDahil += net + kdvTutar;
    return acc;
  },
  { tutar: 0, iskonto: 0, net: 0, kdvDahil: 0 }
);



  const format = (num) => new Intl.NumberFormat("tr-TR").format(num.toFixed(2));

  return (
    <div style={{ padding: 20, overflowX: "auto" }}>
      <h2 style={{ textAlign: "left", color: "#334155", fontSize: 22, fontWeight: "bold", marginBottom: 20 }}>
        Fatura Girişi
      </h2>

      <table style={{ borderCollapse: "collapse", width: "100%", minWidth: "1200px", fontSize: "13px" }}>
        <thead style={{ backgroundColor: "#e2e8f0" }}>
          <tr>
            {"Fatura No,Firma,Tarih,Plaka,Ürün Adı,Adet,Fiyat,KDV,İskonto %,Açıklama"
              .split(",")
              .map((h, i) => (
                <th
                  key={i}
                  style={{ border: "1px solid #ccc", padding: "8px", textAlign: "center" }}
                >
                  {h}
                </th>
              ))}
          </tr>
        </thead>
        <tbody>
          {satirlar.map((s, i) => (
            <tr key={i}>
              {["faturaNo", "firmaAdi", "tarih", "plaka", "urunAdi", "adet", "fiyat", "kdv", "iskonto", "aciklama"].map(
                (key) => (
                  <td key={key} style={{ border: "1px solid #ccc", padding: "4px" }}>
                    <input
                      type={
                        key === "tarih"
                          ? "date"
                          : key === "adet" || key === "fiyat" || key === "kdv"
                          ? "text"
                          : "text"
                      }
                      value={s[key]}
                      onChange={(e) => handleChange(i, key, e.target.value)}
                      style={{ width: "100%", border: "none", outline: "none", fontSize: "12px" }}
                      list={
                        key === "firmaAdi"
                          ? "firmalar"
                          : key === "plaka"
                          ? "plakalar"
                          : key === "urunAdi"
                          ? "urunler"
                          : undefined
                      }
                    />
                  </td>
                )
              )}
            </tr>
          ))}
        </tbody>
      </table>

      <datalist id="firmalar">{firmalar.map((f, i) => <option key={i} value={f.adi} />)}</datalist>
      <datalist id="plakalar">{plakalar.map((p, i) => <option key={i} value={p} />)}</datalist>
      <datalist id="urunler">{urunler.map((u, i) => <option key={i} value={u} />)}</datalist>

<div style={{ marginTop: 10, fontSize: "13px", fontWeight: "bold" }}>
Toplam Tutar: {format(toplam.tutar)} ₺ | 
İskonto: {format(toplam.iskonto)} ₺ | 
Net Tutar: {format(toplam.net)} ₺ | 
KDV Dahil Toplam: {format(toplam.kdvDahil)} ₺
</div>


      <div style={{ marginTop: 20 }}>
        <button
          onClick={handleKaydet}
          style={{
            backgroundColor: "#4f46e5",
            color: "white",
            padding: "10px 20px",
            fontWeight: "bold",
            borderRadius: 6,
            border: "none",
            cursor: "pointer",
          }}
        >
          Kaydet
        </button>
      </div>
    </div>
  );
};

export default FaturaGirisi;
